var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Scene',{attrs:{"infoList":_vm.infoList,"imgList":_vm.imgList,"btns":_vm.btns},on:{"toggleScreen":_vm.toggleScreen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }